import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const onLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 left-0 right-0 z-50 glass"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 sm:px-10 h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-sm bg-gold flex items-center justify-center">
            <span className="font-display text-black text-lg font-bold">V</span>
          </div>
          <span className="font-display text-lg tracking-tight">
            Vision <span className="text-gold">Fashions</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-300">
          <a href="/#services" data-testid="nav-services" className="hover:text-white transition-colors">Services</a>
          <a href="/#packages" data-testid="nav-packages" className="hover:text-white transition-colors">Packages</a>
          <a href="/#launch-offer" data-testid="nav-trips" className="hover:text-white transition-colors">Trips</a>
          <a href="/#ranks" data-testid="nav-ranks" className="hover:text-white transition-colors">Ranks</a>
          <a href="/#how-it-works" data-testid="nav-how" className="hover:text-white transition-colors">How it works</a>
          <a href="/#testimonials" data-testid="nav-testimonials" className="hover:text-white transition-colors">Voices</a>
        </nav>

        <div className="flex items-center gap-3">
          {user && user.role === "admin" && loc.pathname !== "/admin" && (
            <Button
              data-testid="nav-admin-btn"
              onClick={() => nav("/admin")}
              variant="outline"
              className="bg-transparent border-white/10 text-white hover:bg-white/5"
            >
              <Shield className="w-4 h-4 mr-2" /> Admin
            </Button>
          )}
          {user && (
            <>
              {loc.pathname !== "/dashboard" && (
                <Button
                  data-testid="nav-dashboard-btn"
                  onClick={() => nav("/dashboard")}
                  className="bg-gold text-black hover:bg-[#f3e396]"
                >
                  <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
                </Button>
              )}
              <Button
                data-testid="nav-logout-btn"
                onClick={onLogout}
                variant="ghost"
                className="text-slate-300 hover:text-white hover:bg-white/5"
              >
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          )}
          {!user && (
            <>
              <Button
                data-testid="nav-login-btn"
                onClick={() => nav("/login")}
                variant="ghost"
                className="text-slate-300 hover:text-white hover:bg-white/5"
              >
                Sign in
              </Button>
              <Button
                data-testid="nav-signup-btn"
                onClick={() => nav("/register")}
                className="bg-gold text-black hover:bg-[#f3e396] rounded-full px-5"
              >
                Get started
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
